import React from 'react';
import PropTypes from 'prop-types';

import { Card, Image, Table, Button, Icon } from 'semantic-ui-react';
import { scientificFormat } from '../../utils/helpers/formatting';
import { InstagramIcon } from '../../components/dyzio-icons';

const CL = 'cards.large';

const STYLES = {
  smallFont: {
    fontSize: '80%',
  },
  displayBlock: {
    display: 'block',
  },
  noVerticalPadding: {
    padding: '0px 14px',
  },
  empty: {},
  overflowEllipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  smallText: {
    fontSize: '80%',
    lineHeight: '10px',
  },
  lightBackground: {
    backgroundColor: '#eee',
  },
  noPadding: {
    padding: 0,
  },
  smallVerticalPadding: {
    padding: '5px 14px',
  },
};

const TemporaryInfluencerCard = ({ influencer, viewMode, onAddInfluencer }) => {
  const largeCards = (viewMode === CL);
  return (
    <Card key={influencer.handle}>
      <Card.Content textAlign="center" style={STYLES.lightBackground}>
        <Card.Header style={largeCards ? STYLES.empty : STYLES.smallFont}>
          <div style={STYLES.overflowEllipsis}>{influencer.name}&nbsp;</div>
          <div style={STYLES.overflowEllipsis}>{influencer.instagram}&nbsp;</div>
        </Card.Header>
      </Card.Content>

      <Card.Content>
        <Image
          src={influencer.thumbnail}
          size={largeCards ? 'small' : 'tiny'}
          centered
          shape="circular"
          style={STYLES.displayBlock}
        />
      </Card.Content>
      {
        viewMode === CL &&
        <Card.Content style={STYLES.smallVerticalPadding}>
          <Table basic="very" fluid singleLine compact>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing style={STYLES.noPadding}><InstagramIcon /></Table.Cell>
                <Table.Cell style={STYLES.smallText}>{influencer.instagram}</Table.Cell>
                <Table.Cell collapsing style={STYLES.smallText}>
                  {scientificFormat(influencer.instagramCount)}
                </Table.Cell>
                <Table.Cell collapsing style={STYLES.smallText}>
                  {influencer.instagramVerified && <Icon name="check circle" color="blue" />}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Card.Content>
      }

      <Card.Content extra>
        <Button
          inverted
          fluid
          icon
          labelPosition="left"
          color="green"
          value={influencer}
          onClick={onAddInfluencer}
        >
          <Icon name="plus" />
          {`Add${viewMode === CL ? ' to My Influencers' : ''}`}
        </Button>
      </Card.Content>
    </Card>
  );
};

TemporaryInfluencerCard.propTypes = {
  influencer: PropTypes.object.isRequired,
  viewMode: PropTypes.string.isRequired,
  onAddInfluencer: PropTypes.func.isRequired,
};

export default TemporaryInfluencerCard;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-influencers/temporary-influencer-card.js
 **/